import { render, staticRenderFns } from "./PurchasesSpendBonuses.vue?vue&type=template&id=5e785f14"
import script from "./PurchasesSpendBonuses.vue?vue&type=script&lang=js"
export * from "./PurchasesSpendBonuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports